import styled from 'styled-components';

import { Flex } from 'components';
import { Icon } from 'components/icon';
import { SheetButtonsTheme } from 'features/dashboard-new';

export const NavigationWrapper = styled(Flex)``;

export const NavigationIcon = styled(Icon)`
  width: 26px;
`;

export const NavigationButton = styled.div<SheetButtonsTheme>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-style: solid;
  cursor: pointer;

  &:first-child {
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);

    border-right: 0;
  }

  &:last-child {
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 40px;
      height: 35px;

      ${mediaQueries.desktop} {
        width: 50px;
        height: 45px;
      }
    `;
  }}

  background: ${({ theme, buttonBg }) => theme.colors[buttonBg]};
  border-color: ${({ theme, buttonBorderColor }) => theme.colors[buttonBorderColor]};

  ${NavigationIcon} {
    color: ${({ theme, buttonColor }) => theme.colors[buttonColor]};
  }

  &:hover {
    background: ${({ theme, buttonBgHover }) => theme.colors[buttonBgHover]};

    ${NavigationIcon} {
      color: ${({ theme, buttonColorHover }) => theme.colors[buttonColorHover]};
    }
  }

  &.swiper-button-disabled {
    cursor: inherit;

    background: ${({ theme, buttonDisabledBg }) => theme.colors[buttonDisabledBg]};

    ${NavigationIcon} {
      color: ${({ theme, buttonDisabledColor }) => theme.colors[buttonDisabledColor]};
    }

    &:hover {
      background: ${({ theme, buttonDisabledBg }) => theme.colors[buttonDisabledBg]};

      ${NavigationIcon} {
        color: ${({ theme, buttonDisabledColor }) => theme.colors[buttonDisabledColor]};
      }
    }
  }
`;
